const breaking = [
  '今日头条｜年度旗舰发布会现场定价争议持续发酵',
  '消费｜网红茶饮排队被质疑雇人，官方回应来了',
  '娱乐｜综艺收官夜名场面正在被网友逐帧考古',
  '科技｜国产芯片新架构口碑两极，评论区吵翻天',
  '民生｜大促优惠规则被吐槽“绕晕人”登上热搜',
  '职场｜一封简短离职信点燃打工人共鸣',
];

export default function Hero() {
  return (
    <section id="start" className="relative flex min-h-[600px] w-full flex-col justify-end overflow-hidden">
      {/* background */}
      <img
        src="https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20warm%20scene%20of%20people%20gathered%20around%20watching%20a%20glowing%20holographic%20news%20feed%20of%20speech%20bubbles%20and%20exclamation%20marks%2C%20crowd%20silhouettes%20holding%20phones%2C%20warm%20cream%20background%20with%20soft%20coral%20red%20melon%20green%20and%20amber%20accents%2C%20large%20magazine%20editorial%20illustration%2C%20textured%20grain%2C%20no%20text&width=1600&height=900&seq=hero-top&orientation=landscape"
        alt="吃瓜现场热点速报背景插画，群众围观热点新闻"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/45 to-foreground-950/30" />

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-10 pt-32 md:px-6 md:pb-14 md:pt-40">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-50/90 backdrop-blur-sm">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
          </span>
          全网热议 · 24小时滚动围观中
        </span>

        <h1 className="mt-5 max-w-3xl font-display text-3xl font-black leading-tight text-background-50 md:text-5xl">
          一瓜不落，吃瓜现场
          <span className="mt-3 block text-2xl font-bold text-accent-200 md:text-3xl">群众围观现场，实况还原每一个真相</span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-7 text-background-50/85 md:text-base">
          这里是最新鲜的瓜田速递，也是最劲爆的现场直击。实时还原热点事件内幕与真相，第一时间把全网热议焦点摆到你面前。无论你是资深吃瓜人还是新晋围观者，都能在这里蹲到完整实况与深度解析。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a href="#feed" className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600">
            <i className="ri-play-fill" aria-hidden="true" /> 进入瓜田速递
          </a>
          <a href="#trending" className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10">
            <i className="ri-fire-line" aria-hidden="true" /> 看看今日热搜
          </a>
        </div>
      </div>

      {/* breaking ticker */}
      <div className="relative border-t border-background-50/15 bg-foreground-950/45 backdrop-blur-sm">
        <div className="mx-auto flex max-w-7xl items-center px-4 py-2.5 md:px-6">
          <span className="mr-4 flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-bold text-background-50">
            <i className="ri-dvd-line" aria-hidden="true" /> 瓜田速递
          </span>
          <div className="relative flex-1 overflow-hidden" aria-label="滚动快讯">
            <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
              {breaking.concat(breaking).map((t, i) => (
                <span key={i} className="flex items-center gap-2 text-xs text-background-50/90">
                  <i className="ri-arrow-right-up-fill text-accent-300" aria-hidden="true" /> {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}